import React from 'react';
import { ArtRequest } from '../RequestForm';
import './StepStyles.css';

interface DoodleStepProps {
  formData: ArtRequest;
  updateFormData: (data: Partial<ArtRequest>) => void;
  onNext: () => void;
  onBack: () => void;
}

const DoodleStep: React.FC<DoodleStepProps> = ({
  formData,
  updateFormData,
  onNext,
  onBack
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.firstName && formData.lastName && formData.artDescription && formData.isOver18) {
      onNext();
    }
  };

  return (
    <div className="step-container">
      <h2 className="step-title">tell us about your doodle</h2>
      <p className="step-description">
        your name so we know who it's for, and what you'd like us to draw.
      </p>

      <form onSubmit={handleSubmit} className="step-form">
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="firstName">First Name *</label>
            <input
              type="text"
              id="firstName"
              value={formData.firstName}
              onChange={(e) => updateFormData({ firstName: e.target.value })}
              required
              placeholder="Your first name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="lastName">Last Name *</label>
            <input
              type="text"
              id="lastName"
              value={formData.lastName}
              onChange={(e) => updateFormData({ lastName: e.target.value })}
              required
              placeholder="Your last name"
            />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="artDescription">What Should We Draw? *</label>
          <textarea
            id="artDescription"
            value={formData.artDescription}
            onChange={(e) => updateFormData({ artDescription: e.target.value })}
            required
            placeholder="Describe what kind of doodle you'd like, or just tell me what's going on with you"
            rows={5}
          />
        </div>

        <div className="form-group">
          <label className="checkbox-row" htmlFor="over18">
            <input
              type="checkbox"
              id="over18"
              checked={Boolean(formData.isOver18)}
              onChange={(e) => updateFormData({ isOver18: e.target.checked })}
            />
            <span>I confirm I am 18 years or older *</span>
          </label>
        </div>

        <div className="button-group">
          <button type="button" className="btn-secondary" onClick={onBack}>
            Back
          </button>
          <button type="submit" className="btn-primary" disabled={!formData.isOver18}>
            Next: Delivery Info
          </button>
        </div>
      </form>
    </div>
  );
};

export default DoodleStep;
